import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import AlertModal from 'web/components/AlertModal';
import CloseIconBlackBg from 'web/assets/svg/CloseIconBlackBg'
import { getActivityLogs } from 'redux/actions/myNetwork';
import { Table } from 'reactstrap';
import { BoxContainer, BoxContainerHeader, ActionBtn, LogsTableWrapper } from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";

const ActivityLogs = ({ pageLanguageContents, closeIconCallBack }) => {
  const dispatch = useDispatch();
  let history = useHistory();

  const token = localStorage.getItem('token');
  const [networkResponse, setNetworkResponse] = useState([]);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);


  useEffect(() => {
    if (!localStorage.getItem('token')) {
      history.push('/sign-in')
      window.location.reload(false);
    } else {
      getNetworkRequests();
    }
  }, []);

  const getNetworkRequests = async () => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let response = await dispatch(getActivityLogs(token));

      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
          setNetworkResponse(response.payload);
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  const tableHeaders = [
    { id: 'Type/Date', displayName: 'Type/Date' },
    { id: 'GroupName', displayName: 'Group Name' },
    { id: 'InvitedMembers', displayName: 'Invitees' },
  ]

  return (
    <BoxContainer>
      <>
        <BoxContainerHeader>
          <h2>{pageLanguageContents?.Activity_Logs[0]?.Logs}</h2>{" "}
          <CloseIconBlackBg
            onClick={() => {
              closeIconCallBack();
            }}
          />
        </BoxContainerHeader>

        <LogsTableWrapper>
          <Table responsive>
            <thead>
              <tr>
                {tableHeaders.map((items, index) => (
                  <th key={index}>{items.displayName}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {networkResponse.map((items, index) => (
                <tr key={index}>
                  <td style={{ width: '100px' }}>
                    {items.type === 'NON_GROUP' ? `Referral-${moment(items.inviteDate).format("MM/DD/YYYY")}` :
                      items.type === 'GROUP' ? `Group-${moment(items.inviteDate).format("MM/DD/YYYY")}` : ''}
                  </td>
                  <td style={{ width: '200px' }}>{items.networkName ?? 'NA'}</td>
                  <td >{items.emails.join(', ')}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {networkResponse.length === 0 && (
            <p style={{ textAlign: 'center' }}>
              {pageLanguageContents?.Activity_Logs[1]?.NoFound}
            </p>
          )}
        </LogsTableWrapper>

        <ActionBtn>
          <button
            onClick={() => {
              closeIconCallBack();
            }}
          >
            {pageLanguageContents?.CreateGroup[7]?.Back}
          </button>
        </ActionBtn>

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=""
          content={modalContent}
          link={modalLink}
        />
      </>
    </BoxContainer>
  );
}

export default ActivityLogs;
